import {Injectable} from "@angular/core";
import {AppVersionNative} from "@app/core/shared/domain/app-version.native";
import { Observable } from "rxjs";

/**
 * Use case for retrieving the native application's version number.
 */
@Injectable({
    providedIn: 'root'
})
export class GetVersionNumberUseCase {
    constructor(private appVersionNative:AppVersionNative) {
    }

    /**
     * Executes the retrieval of the version number.
     * @returns {Observable<string>} An Observable emitting the native app's version number (e.g., "1.0.0").
     *                              If the version number cannot be retrieved (like on web), the Observable emits an empty string.
     */
    execute(): Observable<string> {
        return this.appVersionNative.getVersionNumber();
    }
}